export default __webpack_public_path__ + "static/media/2f.30ea6f41.png";